import { request } from '../../Services/Api';
import { buildFormData, formDataHeaders } from '../../Utils/utils';

// Arrays → repeated params (?x=a&x=b) without "[]" in the key; axios 0.21 would send x[]=a&x[]=b
const toSearchParams = (params = {}) => {
  const searchParams = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null) return

    if (Array.isArray(value)) {
      value.forEach((item) => searchParams.append(key, item))
    } else {
      searchParams.append(key, value)
    }
  })

  return searchParams
}

export const getAdminBusinessAccounts = (params) =>
  request.api.get(`/user/business-account/get_list_of_users_for_admin/`, toSearchParams(params))
export const deleteUserBusinessAccount = (business_id) =>
  request.api.delete(`/user/business-account/${business_id}/delete_business_account/`)
export const getBusinessAccountsFilterOptions = () =>
  request.api.any({ method: "GET", url: "/user/business-account/filter_options/" })
export const getBusinessAccountsExport = ({ file_name, ...params }) =>
  request.api.get(`/user/business-account/export_user_data/`, toSearchParams(params))

export const getAlertsChart = ({ business_id, ...data }) =>
  request.api.get(`/user/business-account/${business_id}/alerts_statistics/`, data)

export const getStatisticsAdmin = (params) =>
  request.api.get(`/user/business-account/statistics_for_admin_pages/`, params)

export const getBaCommentData = ({ba_id, owner}) => {
  if (owner) {
    return request.api.get(`/admin_panel/business-accounts/${ba_id}/comments/owner/`)
  } else {
    return request.api.get(`/admin_panel/business-accounts/${ba_id}/comments/ba/`)
  }
}

export const saveBaComment = ({ba_id, comment_id, comment, owner, ...data}) => {
  // The form field is named `comment`, but the API write serializer expects `comment_text`
  // (admin_panel UserCommentCreateUpdateSerializer). Map it so the text actually persists.
  const formData = buildFormData({...data, comment_text: comment}, 'file_list')
  const url = owner
    ? `/admin_panel/business-accounts/${ba_id}/comments/owner/`
    : `/admin_panel/business-accounts/${ba_id}/comments/ba/`
  if (comment_id) {
    return request.api.patch(url, formData, { headers: formDataHeaders })
  } else {
    return request.api.post(url, formData, { headers: formDataHeaders })
  }
}

export const deleteBaComment = ({ba_id, owner}) =>
  request.api.delete(owner
    ? `/admin_panel/business-accounts/${ba_id}/comments/owner/`
    : `/admin_panel/business-accounts/${ba_id}/comments/ba/`)

export const deleteBaCommentAttachment = ({ba_id, comment_id, ...params }) => {
  return request.api.delete(`/admin_panel/business-accounts/${ba_id}/comments/${comment_id}/attachments/delete/`, params)
}
